import { useQuery } from "@tanstack/react-query";

import { queryClient } from "@/lib/query/queryClient";

import { FilesystemAPI } from "../api/filesystemApi";

/** The categories and document types a case's files can be filed under. */
export const useCaseTaxonomy = (individualId: string, enabled = true) =>
  useQuery(
    {
      queryKey: ["case-fs-taxonomy", individualId],
      queryFn: () => FilesystemAPI.getTaxonomy(individualId),
      enabled,
      staleTime: 5 * 60_000,
      refetchOnWindowFocus: false
    },
    queryClient
  );
